// extracted by mini-css-extract-plugin
export default {"highlight":"highlight___Wk25U"};